
import React from "react";

interface CustomEditorProps {
  content?: any;
  onContentChange?: (field: string, value: any) => void;
}

const CustomEditor: React.FC<CustomEditorProps> = () => {
  return (
    <div className="space-y-4">
      <p className="text-center text-gray-500">
        עורך דפים מותאמים אישית יתווסף בגרסה הבאה
      </p>
    </div>
  );
};

export default CustomEditor;
